export default "__VITE_ASSET__C_9SD_0p__"